export default (allItems, preselectedItems, display, toggle, reset, link, noSpecialChars, identifier, simpleAll) => ({

    allItems: allItems,
    preselectedItems: preselectedItems,
    display: display,
    toggle: toggle,
    reset: reset,
    link: link,
    noSpecialChars: noSpecialChars,
    identifier: identifier,
    simpleAll: simpleAll,
    selectedItems: [],
    availableItems: [],
    searchQuery: '',
    filteredResults: [],
    alternateSearchQuery: '',

    init() {
        this.availableItems = this.allItems;

        this.setItems(this.preselectedItems);

        this.filteredResults = this.availableItems;
    },

    searchItems() {
        if (this.searchQuery) {
            if (noSpecialChars){
                this.alternateSearchQuery = this.searchQuery.replace(/[^A-Za-z0-9]/g, '');
            }
            else {
                this.alternateSearchQuery = this.searchQuery;
            }
            this.filteredResults = this.allItems.filter(item =>
                item[this.display].toLowerCase().includes(this.searchQuery.toLowerCase()) ||
                item[this.identifier].toString().toLowerCase().includes(this.searchQuery.toLowerCase()) ||
                item[this.display].toLowerCase().includes(this.alternateSearchQuery.toLowerCase()) ||
                item[this.identifier].toString().toLowerCase().includes(this.alternateSearchQuery.toLowerCase())
            ).filter(item =>
                !this.selectedItems.includes(item)
            );
        } else {
            this.filteredResults = this.availableItems;
        }
    },

    toggleAll() {
        this.availableItems.length > 0 ? this.checkAll() : this.uncheckAll();
    },

    uncheckAll() {
        this.availableItems.push(...this.selectedItems);
        this.availableItems.sort((a, b) => (a[this.display] > b[this.display]) ? 1 : -1);
        this.selectedItems = [];
        this.filteredResults = this.availableItems;
    },

    uncheckItem(item) {
        this.selectedItems.splice(this.selectedItems.indexOf(item), 1);
        this.availableItems.push(item);
        this.availableItems.sort((a, b) => (a[this.display] > b[this.display]) ? 1 : -1);
    },

    checkAll() {
        this.selectedItems.push(...this.availableItems);
        this.selectedItems.sort((a, b) => (a[this.display] > b[this.display]) ? 1 : -1);
        this.availableItems = [];
        this.filteredResults = [];
    },

    checkItem(item, $refs) {
        this.availableItems.splice(this.availableItems.indexOf(item), 1);
        this.selectedItems.push(item);
        this.selectedItems.sort((a, b) => (a[this.display] > b[this.display]) ? 1 : -1);

        if($refs) {
            //clear search query and filtered results after an item is selected
            this.searchQuery = '';
            this.filteredResults = this.availableItems;

            this.$nextTick(() => {
                $refs.searchInput.focus();
            });
        }

    },

    setItems(setItems) {

        if (setItems) {
            setItems.forEach((setItem) => {

                let foundItem = (this.availableItems.find((item) => {
                    return setItem == item.id;
                }));

                if (foundItem) {
                    this.checkItem(foundItem);
                }
            });
        }
    },

    resetItems() {
        this.uncheckAll();
        this.setItems(this.preselectedItems);
    },
});
